import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context";
import { getAccess } from "../../../permissions/Permissions";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const CallCenterNav = () => {
  const theme = useTheme();
  const auth = useAuth();
  const user = auth?.user;
  const permissions = getAccess(user?.user?.permissions, user?.user?.isAdmin);
  const { t } = useTranslation();
  const [value, setValue] = useState("/call-center");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  // Update the current tab based on the URL pathname.
  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/call-center",
      "/call-center/add-client",
      "/call-center/view-client",
      "/call-center/patients",
      "/call-center/employees",
      "/call-center/transfer-clients",
      "/call-center/search",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/call-center");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "none" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            {/* <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/call-center"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/call-center" ? "white" : "black",
              }}
              label={t("hr.dashboard")}
              value="/call-center"
              component={NavLink}
              to="/call-center"
            /> */}

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/call-center/add-client"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/call-center/add-client" ? "white" : "black",
              }}
              label={t("call_center.addClient")}
              value="/call-center/add-client"
              component={NavLink}
              to="/call-center/add-client"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/call-center/view-client"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/call-center/view-client" ? "white" : "black",
              }}
              label={t("call_center.clientView")}
              value="/call-center/view-client"
              component={NavLink}
              to="/call-center/view-client"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/call-center/view-procedure"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/call-center/view-procedure" ? "white" : "black",
              }}
              label={t("call_center.viewProcedure")}
              value="/call-center/view-procedure"
              component={NavLink}
              to="/call-center/view-procedure"
            />

            {permissions?.is_staff && (
              <Tab
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === "/call-center/transfer-clients"
                      ? theme.palette.primary.main
                      : "white",
                  color:
                    value === "/call-center/transfer-clients"
                      ? "white"
                      : "black",
                }}
                label={t("call_center.transferClients")}
                value="/call-center/transfer-clients"
                component={NavLink}
                to="/call-center/transfer-clients"
              />
            )}

            {(permissions?.is_staff ||
              (permissions?.is_manager_in_call_center &&
                !permissions?.call_center_admin)) && (
              <Tab
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === "/call-center/in-progress"
                      ? theme.palette.primary.main
                      : "white",
                  color:
                    value === "/call-center/in-progress" ? "white" : "black",
                }}
                label={t("call_center.inProgress", "In Progress")}
                value="/call-center/in-progress"
                component={NavLink}
                to="/call-center/in-progress"
              />
            )}

            {(permissions?.is_staff ||
              (permissions?.is_manager_in_call_center &&
                !permissions?.call_center_admin)) && (
              <Tab
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === "/call-center/employees"
                      ? theme.palette.primary.main
                      : "white",
                  color: value === "/call-center/employees" ? "white" : "black",
                }}
                label={t("call_center.employees")}
                value="/call-center/employees"
                component={NavLink}
                to="/call-center/employees"
              />
            )}

            {(permissions?.is_staff ||
              permissions?.is_manager_in_call_center ||
              permissions?.call_center_admin) && (
              <Tab
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === "/call-center/search"
                      ? theme.palette.primary.main
                      : "white",
                  color: value === "/call-center/search" ? "white" : "black",
                }}
                label={t("call_center.search", "Search")}
                value="/call-center/search"
                component={NavLink}
                to="/call-center/search"
              />
            )}

            {(permissions?.is_staff ||
              (permissions?.is_manager_in_call_center &&
                permissions?.call_center_admin === false)) && (
              <Tab
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === "/call-center/follow_ups"
                      ? theme.palette.primary.main
                      : "white",
                  color:
                    value === "/call-center/follow_ups" ? "white" : "black",
                }}
                label={t("call_center.followUps", "Follow Up")}
                value="/call-center/follow_ups"
                component={NavLink}
                to="/call-center/follow_ups"
              />
            )}
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default CallCenterNav;
